import React from "react"
import strings from "../../../../localization/strings"
import { ELanguage, IQuestion, IQuestionDocument } from "../../../../models"
import { EnumValues } from "enum-values"
import QuestHTMLViewer from "./QuestHTMLViewer"
import AccountStore from "../../../../stores/AccountStore"
import * as api from "../../../../api"
interface IProps {

}
interface IState {
    preQuestions: IQuestionDocument
}

export default class PunchPreQuestions extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            preQuestions: null
        }
    }

    componentDidMount() {
        api.getPreQuestions(AccountStore.getCurrentAccount().Id).then(res => this.setState({ preQuestions: res.data }));
    }

    render() {
        if (this.state.preQuestions === null) return null
        const introductions = this.state.preQuestions.Introduction
        introductions.sort((a, b) => a.Language - b.Language)
        const questions = this.state.preQuestions.Questions
        questions.sort((a, b) => a.Language - b.Language).sort((a, b) => a.GroupId - b.GroupId)
        let questionCount = 0
        questions.forEach(item => {
            if (item.GroupId > questionCount)
                questionCount = item.GroupId
        })
        let orderedQuestions: IQuestion[][] = []
        for (let i = 1; i <= questionCount; i++) {
            orderedQuestions.push(questions.filter(item => item.GroupId === i))
        }
        return (
            <div style={{ marginTop: 15 }}>
                <div>
                    <div>{strings.PreQuestionNote1}</div>
                    <div>{strings.PreQuestionNote2}</div>
                </div>
                <div style={{ display: "flex", marginTop: 15 }}>
                    {introductions.map(intro =>
                        <div style={{ flex: 1 }} key={intro.Language}>
                            <QuestHTMLViewer
                                lang={intro.Language}
                                order="intro"
                                title={strings.formatString(strings.Introduction_Page_Message_Lang, EnumValues.getNameFromValue(ELanguage, intro.Language)) as string}
                                body={intro.Body}
                            />
                        </div>
                    )}
                </div>
                {orderedQuestions.map((questGroup, index) =>
                    <div style={{ display: "flex", marginTop: 15 }} key={index}>
                        {questGroup.map(question =>
                            <div style={{ flex: 1 }} key={question.Language}>
                                <QuestHTMLViewer
                                    lang={question.Language}
                                    order={question.GroupId}
                                    title={strings.formatString(strings.Question_Num, String(question.GroupId), EnumValues.getNameFromValue(ELanguage, question.Language)) as string}
                                    body={question.Body}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }
}